var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSquare3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.34 1.99979H7.67C4.28 1.99979 2 4.37979 2 7.91979V16.0898C2 19.6198 4.28 21.9998 7.67 21.9998H16.34C19.73 21.9998 22 19.6198 22 16.0898V7.91979C22 4.37979 19.73 1.99979 16.34 1.99979Z",
    fill: "#605BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1246 8.1893C11.1246 8.6713 11.5156 9.0643 11.9946 9.0643C12.4876 9.0643 12.8796 8.6713 12.8796 8.1893C12.8796 7.7073 12.4876 7.3143 12.0046 7.3143C11.5196 7.3143 11.1246 7.7073 11.1246 8.1893ZM12.8696 11.3621C12.8696 10.8801 12.4766 10.4871 11.9946 10.4871C11.5126 10.4871 11.1196 10.8801 11.1196 11.3621V15.7821C11.1196 16.2641 11.5126 16.6571 11.9946 16.6571C12.4766 16.6571 12.8696 16.2641 12.8696 15.7821V11.3621Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquare3);
export default __webpack_public_path__ + "static/media/info-square-3.ae3557cafedf36ec3cd8739a2cf71a28.svg";
export { ForwardRef as ReactComponent };